import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function useSmoothScroll() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash)
        if (element) {
          const offsetTop = element.offsetTop - 80 // Ajuste para navbar fija
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          })
        }
      }, 100)
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [pathname, hash])
}
